import React from "react";
import { FieldArray } from "formik";
import { Table } from "react-bootstrap";
import { FormArrayTextField } from "../../../../../../partials/content/Forms/FormField";
import Illustration from "../../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";
const ItemsTransferCost = ({ values, onBlur, setFieldValue }) => {
  const calculateTotalCost = (values) => {
    let totalCost = 0;
    if (values) {
      values.itemsTransferCost.forEach((value) => {
        if (value.cost > 0) {
          totalCost += parseFloat(value.cost);
        }
      });
    }
    return totalCost;
  };
  return (
    <React.Fragment>
      <FieldArray name="itemsTransferCost">
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values.itemsTransferCost &&
                    values.itemsTransferCost.length > 0 ? (
                      <thead className="text-center">
                        <tr>
                          <th style={{ width: "50%" }}>Cost Name</th>
                          <th style={{ width: "40%" }}>Cost</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody>
                      {values.itemsTransferCost &&
                      values.itemsTransferCost.length > 0 ? (
                        values.itemsTransferCost.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="itemsTransferCost"
                                  index={index}
                                  propName="costName"
                                  margin="none"
                                  placeholder="Hint: Add delivery cost such as freight, etc"
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="itemsTransferCost"
                                  index={index}
                                  propName="cost"
                                  currencyField
                                  margin="none"
                                  currencyCode={values.currencyCode}
                                  onBlur={(e) => {
                                    setFieldValue(
                                      "totalCost",
                                      calculateTotalCost(values)
                                    );
                                    onBlur(e);
                                  }}
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                <BootstrapTooltip title="Delete Transfer Cost">
                                  <button
                                    type="button"
                                    className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                    onClick={() => {
                                      remove(index);
                                    }}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                </BootstrapTooltip>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td className="text-center py-3" colSpan="3">
                            <Illustration
                              imageSource="INVIFO Sales.png"
                              guidance="You don't have any Transfer Cost items yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td className="text-center py-3" colSpan="3">
                          <button
                            type="button"
                            className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                            onClick={() =>
                              push({
                                ID: 0,
                                costName: "",
                                cost: 0,
                              })
                            }
                          >
                            <i className="fas fa-plus-circle"></i>
                            Add Transfer Cost Item
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </FieldArray>
    </React.Fragment>
  );
};

export default ItemsTransferCost;
